module.exports = __webpack_public_path__ + "img/tram-selected.d63de0cc.svg";